<template>
	<section id="files-card">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<template v-if="filesStates !== null">
			<b-row>
				<b-col
					cols="4"
					v-for="fileData in singleFiles"
					:key="fileData.key"
				>
					<b-card class="mb-2 logo text-center" :title="fileData.label">
						<div class="box-image">
							<img v-if="fileData.file.type === 'image/png' || fileData.file.type === 'image/jpg' || fileData.file.type === 'image/jpeg'" :src="fileData.file.url"/>
							<md-icon v-else icon="description"/>
							<b-button v-if="!unableEdit && !unableDelete" class="delete-image" @click="() => deleteFile(fileData.file.id)" variant="danger" size="sm"><md-icon icon="delete"/></b-button>
							<b-button class="download-image" :href="fileData.file.url" download variant="warning" target="_blank" size="sm"><md-icon icon="get_app"/></b-button>
						</div>
						<b-card-body v-if="!unableEdit">
							<div v-if="fileData.update" class="mt-3">
								<b-form-file
									v-model="fileData.input"
									:state="Boolean(fileData.input)"
									drop-placeholder="Drop file here..."
									class="mb-4 input-file"
								></b-form-file>
								<b-button @click="fileData.update = false" variant="warning">{{$t('global.cancel')}}</b-button>
								<b-button @click="() => updateFile(fileData)" variant="primary">{{$t('global.upload')}}</b-button>
							</div>
							<b-button v-else @click="fileData.update = true" variant="warning">{{$t('global.change')}}</b-button>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
			<b-card
				v-for="fileData in collectionFiles"
				:key="fileData.key"
				class="mb-2"
			>
				<b-row v-if="fileData.files.length>0">
					<b-col
						cols="3"
						v-for="(file,i) in fileData.files"
						:key="i"
					>
						<div class="box-image">
							<img v-if="file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'" :src="file.url"/>
							<md-icon v-else icon="description"/>
							<b-button v-if="!unableEdit && !unableDelete" class="delete-image" @click="() => deleteFile(file.id)" variant="danger" size="sm"><md-icon icon="delete"/></b-button>
							<b-button class="download-image" :href="file.url" download variant="warning" target="_blank" size="sm"><md-icon icon="get_app"/></b-button>
						</div>
					</b-col>
				</b-row>
				<p v-else>{{ $t('filesRelated.emptyImg') }}</p>
				<hr>
				<b-row class="mt-4" align-h="between" v-if="!unableEdit">
					<b-col cols="4">
						<b-form-file
							class="input-file"
							v-model="fileData.input"
							:state="Boolean(fileData.input)"
							drop-placeholder="Drop file here..."
						/>
					</b-col>
					<b-col cols="4" class="text-right">
						<b-button v-if="!fileData.loading" @click="() => updateFile(fileData)" variant="primary">{{$t('global.add')}}</b-button>
						<b-spinner v-else small />
					</b-col>
				</b-row>
			</b-card>
		</template>
		<template></template>
	</section>
</template>

<script>
// import MainLayout from '../layout/MainLayout.vue'
// import api from '../../../api.js'

export default {
	props : {
		modelId : {
			type: Number,
			required: true,
		},
		modelReference : {
			type: String,
			required: true,
		},
		fileKeys : {
			type: Array,
			required: true,
		},
		counter : {
			type: Array,
			required: false,
		},
		unableEdit : {
			type: Boolean,
			default: false,
		},
		unableDelete : {
			type: Boolean,
			default: false,
		},
	},
	components: {  },
	data(){
		// const translatableValues = {}
		return {
			loading:false,
			filesStates : null,
		}
	},
	computed : {
		singleFiles(){
			return this.filesStates !== null ? this.filesStates.filter(fileState => fileState.type === 'single') : []
		},
		collectionFiles(){
			return this.filesStates !== null ? this.filesStates.filter(fileState => fileState.type === 'collection') : []
		},
		countFiles(){
			return this.filesStates !== null ? this.filesStates.map(fileState => ({
				key:fileState.key,
				count:fileState.type === 'single' ? (fileState.id > 0 ? 1 : 0) : fileState.files.length,
			})) : []
		}
	},
	methods:{
		deleteFile(fileId){
			this.loading = true
			this.$root.api.delete(
				`files/${this.modelReference}/${this.modelId}/${fileId}`,
			).then(() => {
				this.$root.showAlert(this.$t('filesRelated.fileDelete'))
				this.loadFiles();
			}).catch(this.$root.handleRequestError);
		},
		updateFile(fileState){
			if (fileState.input === null) {
				this.$root.showAlert(this.$t('filesRelated.notSelectImg'),{variant:'danger'})
				return
			}
			let formData = new FormData();
			formData.append('file',fileState.input)
			formData.append('keyName',fileState.key)
			this.loading = true
			this.$root.api.post(
				`files/${this.modelReference}/${this.modelId}`,
				formData,
				{ headers:{'Content-Type': 'multipart/form-data'}}
			).then(() => {
				this.$root.showAlert(this.$t('filesRelated.uploadedFile'))
				this.loading = false
				this.loadFiles();
			}).catch(this.$root.handleRequestError);
		},
		initFilesStates(){
			this.filesStates = this.fileKeys.map(fileKey => ({
				key:fileKey.keyName,
				loading:false,
				input:null,
				update:false,
				type: fileKey.keyName.indexOf('[]') === -1 ? 'single' : 'collection',
				file:{id:-1,url:'',type:''},
				files:[],
				label:fileKey.label,
			}))
		},
		loadFiles(){
			this.loading = true;
			this.$root.api.get(`files/${this.modelReference}/${this.modelId}`).then((res) => {
				this.filesStates.forEach( fileState => {
					const aux = res.data.find(fileData => fileData.keyName === fileState.key)
					if (aux !== undefined) {
						if (fileState.type === 'single') {
							fileState.file = {id:aux.file.id, url:aux.file.url, type: aux.file.type}
						}else{
							fileState.files = aux.files.map(fileData => ({id:fileData.id, url: fileData.url, type: fileData.type}))
						}
					}
				})
			})
			.catch(this.$root.handleRequestError)
			.then(() => {
				this.loading = false;
			});
		}
	},
	mounted(){
		this.initFilesStates()
		this.loadFiles()
	},
	watch:{
		modelId(){
			// this.initFilesStates()
			// this.loadFiles()
		},
		countFiles(val){
			this.$emit('update:counter',val)
		}
	}
}
</script>

<style scoped>
.input-file{
	max-width:100% !important;
	overflow: hidden;
}
.box-image{
	border: 1px solid black;
	border-radius: 10px;
	font-size: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100px;
	text-align: center;
	position: relative;
	margin-bottom: 20px;
}
.box-image .download-image{
	position: absolute;
	bottom: -15px;
}
.box-image .delete-image{
	position: absolute;
	top: -5px;
	right: -5px;
}
.box-image img{
	max-height: 100%;
	max-width: 100%;
}
#files-card{
	min-height: 200px;
}
</style>
